enum CheckoutActions {
    FETCH_REMINDER_LIST = "checkoutFetchReminderList",
    REFRESH_REMINDER_LIST = "checkoutRefreshReminderList",
    RESOLVE_REMINDER = "checkoutResolveReminder",
    DELETE_REMINDER = "checkoutDeleteReminder",
}

enum CheckoutMutation {
    SET_REMINDER_LIST = "checkoutReminderListResult",
}

export { CheckoutActions, CheckoutMutation };
